import IframeActivity from "./IframeActivity";

export default function ConfusingParent() {
    return (
        <IframeActivity
            src="/activities/confusing-parent/index.html"
            title="Confusing Parent"
        />
    );
}